<template>
  <div class="relative flex-1 overflow-auto rounded-md border">
    <div v-if="loading" class="flex h-full w-full items-center justify-center">
      <LoadingComponent size="small" />
    </div>
    <table v-else class="dashboard-table" style="border-spacing: 0">
      <thead>
        <draggable
          id="dragger"
          v-model="localColumns"
          item-key="name"
          tag="tr"
          :component-data="{ as: 'transition-group' }"
          :revert-on-spill="false"
          :draggable="'.draggable-cell'"
          :move="handleMove"
          @update="handleDrag"
        >
          <template #item="{ index }">
            <DashBoardHeadColumnComponent
              v-model:column="localColumns[index]"
              v-model:sort="localSort"
              v-model:cell-width="cellWidth"
              v-model:require-save-dashboard="localRequireSaveDashboard"
              :index="index"
              :is-last="columns.length === index + 1"
              :resize-able="columns.length > 1"
              :available-column-fields="availableFields"
              @delete:column="handleDeleteColumns"
              @update:dashboard="updateDashboard"
            />
          </template>
        </draggable>
      </thead>
      <tbody>
        <DossierRowComponent
          v-for="(dossier, indexDossier) in dossiers"
          :key="dossier.id"
          :dossier="dossier"
          :columns="columns"
          :index-dossier="indexDossier"
          :cell-width="cellWidthComputed"
          :show-tasks="canShowTask(indexDossier)"
          :active-field="activeFieldFor(indexDossier)"
          :column-id="columnIdFor(indexDossier)"
          @toggle-tasks="handleToggleTasks"
        />
      </tbody>
    </table>
  </div>
</template>
<script>
import DashBoardHeadColumnComponent from '@c/Dashboard/Content/Dossier/components/Head/DashBoardHeadColumnComponent'
import DossierRowComponent from '@c/Dashboard/Content/Dossier/components/Body/DossierRowComponent'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import LoadingComponent from '@c/TheLoadingComponent.vue'

export default {
  name: 'DashBoardTable',
  components: {
    LoadingComponent,
    DossierRowComponent,
    DashBoardHeadColumnComponent,
    draggable
  },
  props: {
    dossiers: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    sort: {
      type: Object,
      required: false,
      default: () => {}
    },
    requireSaveDashboard: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    'update:columns',
    'update:dashboard',
    'update:require-save-dashboard',
    'update:sort',
    'fetch-dossier',
    'on:tasks-visible'
  ],
  data() {
    const cellWidth = {}
    for (let key in this.columns) {
      cellWidth[key] = this.columns[key].visual?.width || 'auto'
    }
    return {
      cellWidth,
      showTasksOfRow: null, // { rowIndex, columnId, field } | null
      currentColumn: null
    }
  },
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata'
    }),
    availableFields() {
      return this.metadata.enums.columns_types || []
    },
    cellWidthComputed() {
      let result = Object.values(this.cellWidth).map((column) =>
        column == 'auto' ? 'auto' : `${Math.round(column)}px`
      )
      return result
    },
    localRequireSaveDashboard: {
      get() {
        return this.requireSaveDashboard
      },
      set(value) {
        this.$emit('update:require-save-dashboard', value)
      }
    },
    localColumns: {
      get() {
        if (this.columns) {
          return this.columns
        }

        return []
      },
      set(value) {
        this.$emit('update:columns', value)
      }
    },
    localSort: {
      get() {
        return this.sort
      },
      set(value) {
        this.$emit('update:sort', value)
      }
    }
  },
  mounted() {},
  methods: {
    handleDrag(e) {
      if (!this.localRequireSaveDashboard) {
        this.localRequireSaveDashboard = true
      }
    },
    handleMove(e) {
      return e.related.previousSibling !== null
    },
    handleDeleteColumns(idx) {
      this.localColumns.splice(idx, 1)
      this.updateDashboard(false)
    },
    updateDashboard(value) {
      this.$emit('update:dashboard', value)
    },
    handleToggleTasks({ rowIndex, columnId, field }) {
      const isSameToggleAlreadyOpen =
        this.showTasksOfRow?.rowIndex === rowIndex &&
        this.showTasksOfRow?.columnId === columnId

      this.showTasksOfRow = isSameToggleAlreadyOpen
        ? null
        : { rowIndex, columnId, field }

      this.$emit('on:tasks-visible', !this.showTasksOfRow)
    },
    canShowTask(rowIndex) {
      return this.showTasksOfRow?.rowIndex === rowIndex
    },
    activeFieldFor(rowIndex) {
      return this.showTasksOfRow?.rowIndex === rowIndex
        ? this.showTasksOfRow.field
        : null
    },
    columnIdFor(rowIndex) {
      return this.showTasksOfRow?.rowIndex === rowIndex
        ? this.showTasksOfRow.columnId
        : null
    }
  }
}
</script>
